import { Model } from 'ng2-app/modules/shared/models/model.class';
import { Request } from 'ng2-app/modules/borrower/models/request/request.model';

export class DocumentCategory extends Model<DocumentCategory> {

    id: number;
    name: string;
    description: string;
    exampleUrl: string;
    timeClassification: string;
    created: Date;
    modified: Date;
    deleted: Date;

    fillable(): string[] {
        return [
            'id',
            'name',
            'description',
            'exampleUrl',
            'timeClassification',
            'created',
            'modified',
            'deleted'
        ];
    }

    serializeable(): string[] {
        return this.fillable();
    }

    requestBlueprints(): Request[] {
        if (this.timeClassification === 'month') {
            return Array(12).fill(1).map((_, n) => {
                const date = new Date();
                date.setDate(1);
                date.setMonth(date.getMonth() - n - 1);
                return new Request({
                    type: 'documentRequest',
                    categoryId: this.id,
                    name: this.name,
                    description: this.description,
                    year: date.getFullYear(),
                    month: date.getMonth() + 1,
                    publishTo: 'borrower',
                    deliverTo: 'lender',
                });
            });
        } else if (this.timeClassification === 'year') {
            return Array(3).fill(1).map((_, n) => {
                const date = new Date();
                date.setDate(1);
                date.setMonth(0);
                date.setFullYear(date.getFullYear() - n - 1);
                return new Request({
                    type: 'documentRequest',
                    categoryId: this.id,
                    name: this.name,
                    description: this.description,
                    year: date.getFullYear(),
                    month: null,
                    publishTo: 'borrower',
                    deliverTo: 'lender',
                });
            });
        } else {
            return [new Request({
                type: 'documentRequest',
                categoryId: this.id,
                name: this.name,
                description: this.description,
                year: null,
                month: null,
                publishTo: 'borrower',
                deliverTo: 'lender',
            })];
        }
    }
}
